<template>
  <div class="confirmPopup">
    <van-dialog v-model="show" :show-confirm-button="false">
      <div class="dialogContent">
        <div class="title">{{ title }}</div>
        <div class="message" :class="{'text-center': textCenter}">{{ message }}</div>
        <div class="btn-group">
        <div class="btn cancel" @click="handleCancelClick" v-if="cancelText">
          {{ cancelText }}
        </div>
        <div class="btn confirm" @click="handleSubmitClick">
          {{ confirmText }}
        </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: "提示",
    },
    message: {
      type: String,
      default: "确认申请吗？",
    },
    confirmText: {
      type: String,
      default: "确认",
    },
    cancelText: {
      type: String,
      default: "",
    },
    //文字是否居中
    textCenter: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
     
    };
  },
  methods: {
    handleCancelClick() {
      this.show = false;
      this.$emit("cancel");
    },
    showPopup() {
      this.show = true;
    },
    hidePopup() {
      this.show = false;
    },
    handleSubmitClick() {
      this.show = false;
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent {
  padding: 20px 16px;
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #333333;
    text-align: center;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .message {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    padding: 20px 0px;
  }
  .text-center {
    text-align: center;
  }
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn{
      border-radius: 23px;
      font-family: PingFang SC, PingFang SC;
      font-size: 16px;
      color: #333333;
      font-style: normal;
      height: 45px;
      width: 45%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cancel{
      background: #F1F1F1;
      color: rgba(51,51,51,0.4);;
    }
    .confirm{
      background-color: #1D70F7;
      color: #fff;
    }
  }
}
</style>
